function cleanData (data: number[]) {
    data = data.map((item)=> item == null ? NaN: item);
    let [hz250, hz500, kh1, kh2, kh3, kh4, kh6, kh8] = data;
    return [ NaN, hz250, hz500, NaN, kh1, NaN, kh2, kh3, kh4, kh6, kh8];
}

export function clean(data:any[]) {
   return data.map(({label, data, attribute = null, profile = null})=> {
            return {label, data: cleanData(data), attribute, profile};
   });
};

const POINT_RADIUS = 8;

export const ProfileList:any = {
    "left": {
        label: 'Left Ear',
        data:[],
        fill: false,
        pointStyle: "crossRot",
        borderWidth:2,
        borderColor: '#ee343b',
        tension: 0.1,
        pointRadius: POINT_RADIUS,
        spanGaps:true,
        pointBorderColor(ctx:any, options:any) {
          return '#ee343b';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        },
       
    },
    "left-dashed": {
        label: 'Left Ear',
        data:[],
        fill: false,
        pointStyle: "crossRot",
        borderWidth:2,
        borderColor: '#292872',
        tension: 0.1,
        pointRadius: POINT_RADIUS,
        spanGaps:true,
        borderDash: [10,5],
        pointBorderColor(ctx:any, options:any) {
          return '#292872';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        },
       
    },
    "right":  {
        label: 'Right Ear',
        data: [],
        fill: false,
        backgroundColor: 'transparent',
        borderColor: '#292872',
        pointStyle: "circle",
        borderWidth:2,
        tension: 0.1,
        spanGaps: true,
        pointRadius: POINT_RADIUS,
        pointBorderColor(ctx:any, options:any) {
          return '#292872';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        }
      },
      "right-dashed":  {
        label: 'Right Ear',
        data: [],
        fill: false,
        backgroundColor: 'transparent',
        borderColor: '#ee343b',
        pointStyle: "circle",
        borderWidth:2,
        tension: 0.1,
        spanGaps: true,
        pointRadius: POINT_RADIUS,
        borderDash: [10,5],
        pointBorderColor(ctx:any, options:any) {
          return '#ee343b';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        }
      },
      'mf2-left-aahl': {
        label: 'MF2 Left',
        data: [],
        fill: false,
        backgroundColor: 'transparent',
        borderColor: '#1F497D',
        pointStyle: 'none',
        borderDash: [5,5],
        borderWidth: 2,
        tension: 0.1,
        spanGaps: true,
        pointRadius: 0,
        pointBorderColor(ctx:any, options:any) {
          return '#1F497D';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        }
      },
      'mf2-right-aahl': {
        label: 'MF2 Right',
        data: [],
        fill: false,
        backgroundColor: 'transparent',
        borderColor: '#1F497D',
        pointStyle: 'none',
        borderDash: [5,5],
        borderWidth:2,
        tension: 0.1,
        spanGaps: true,
        pointRadius: 0,
        pointBorderColor(ctx:any, options:any) {
          return '#1F497D';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        }
      },
      'mf2-left-aahl-pts': {
        label: 'MF2 Left + PTS',
        data: [],
        fill: false,
        backgroundColor: 'transparent',
        borderColor: '#DA8137',
        pointStyle: false,
        lineDashOffset: 1.1,
        borderDash: [5,5],
        borderWidth:2,
        tension: 0.1,
        spanGaps: true,
        pointRadius: POINT_RADIUS,
        pointBorderColor(ctx:any, options:any) {
          return '#DA8137';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        }
      },
      'mf2-right-aahl-pts': {
        label: 'MF2 Right + PTS',
        data: [],
        fill: false,
        backgroundColor: 'transparent',
        borderColor: '#DA8137',
        pointStyle: false,
        borderDash: [5,5],
        borderWidth:2,
        tension: 0.1,
        spanGaps: true,
        pointRadius: POINT_RADIUS,
        pointBorderColor(ctx:any, options:any) {
          return '#DA8137';
        },
        pointBackgroundColor(ctx:any, options:any) {
          return "transparent";
        }
      }
}

function populateOptionBasedOnAttribute(attribute: any) {
    let config:any = {};
    if(attribute?.color){
        config.borderColor = attribute?.color;
        config.pointBorderColor = function(ctx:any, options:any){
            return attribute?.color
        }
    }
    return  config
}
export function build(data: [], profile: string| null = "left") {  
    return data.map((item: any)=> {
        let p:string = item.profile ?  item.profile: profile;
        let fac = ProfileList[p];
       if(item?.attribute){
            let attribute: any | null = item?.attribute
            fac = {
                ...fac,
                ...populateOptionBasedOnAttribute(attribute)
            }
            delete item.attribute;
        }
        
        return {...fac, ...item};
    })
}
